interface ETCAppConfigType {
    GET_ETC_SHIPMENTS: string;
    GET_ETC_BASE_DETAILS: string;
    GET_ETC_BUYERSSELLERS_DETAILS: string;
    GET_CERTIFIED_WEIGHT_INFO: string;
    GET_COMPONENTS_DETAILS: string;
    GET_PRODUCT_DETAILS: string;
    GET_INPUT_ETC_PRODUCT_DETAILS: string;
    GET_INPUT_ETC_COMPONENTS_DETAILS: string;
    GET_DECLARATION_SUBMIT_DETAILS: string;
    GET_CB_LANDING_PAGE_COUNTRIES: string;
    CERTIFIED_TRANSACTION_DASHBOARD: string;
}

const ETC_TYPES: any = {
    ETC: "etc",
}

export const ETCAppConfig: ETCAppConfigType = {
    GET_ETC_SHIPMENTS: `${ETC_TYPES.ETC}/get-etc-shipment-consignee-details`,
    GET_ETC_BASE_DETAILS: `${ETC_TYPES.ETC}/get-etc-base-details`,
    GET_ETC_BUYERSSELLERS_DETAILS: `${ETC_TYPES.ETC}/get-etc-buyer-seller-details`,
    GET_CERTIFIED_WEIGHT_INFO: `${ETC_TYPES.ETC}/get-certified-weight-info`,
    GET_COMPONENTS_DETAILS: `${ETC_TYPES.ETC}/get-etc-component-detail`,
    GET_PRODUCT_DETAILS: `${ETC_TYPES.ETC}/get-etc-prod-raw-mat-info`,
    GET_INPUT_ETC_PRODUCT_DETAILS: `${ETC_TYPES.ETC}/get-inputetcdetailsproduct-info`,
    GET_INPUT_ETC_COMPONENTS_DETAILS: `${ETC_TYPES.ETC}/get-input-etc-component-detail`,
    GET_DECLARATION_SUBMIT_DETAILS: `${ETC_TYPES.ETC}/get-etc-declaration-submit-details`,
    GET_CB_LANDING_PAGE_COUNTRIES: `${ETC_TYPES.ETC}/get-buyer-country`,
    CERTIFIED_TRANSACTION_DASHBOARD: `${ETC_TYPES.ETC}/get-etc-cblicensing-code`
}
